import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatError } from "@/lib/api";
import Seo from "@/components/Seo";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login, checking } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (checking) return <div className="min-h-screen grid place-items-center">Loading…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-asphalt text-white grid place-items-center px-4">
      <Seo title="Admin Login | Site Cleanup" />
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <span className="inline-block bg-white p-1.5">
            <img src="/logo.png" alt="Site Cleanup" className="h-9 w-auto block" />
          </span>
          <span className="font-display text-xl uppercase text-white/60">Admin</span>
        </div>
        <form onSubmit={submit} className="bg-white text-asphalt p-8 border border-border" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-safety mb-4"><Lock size={18} /><span className="rs-eyebrow">Restricted access</span></div>
          <h1 className="font-display text-3xl uppercase mb-6">Sign in</h1>
          <label className="block mb-4">
            <span className="rs-label">Email</span>
            <input data-testid="admin-email" type="email" className="rs-input" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="block mb-6">
            <span className="rs-label">Password</span>
            <input data-testid="admin-password" type="password" className="rs-input" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          <button type="submit" disabled={loading} className="rs-btn-primary w-full disabled:opacity-70" data-testid="admin-login-submit">
            {loading ? <><Loader2 className="animate-spin mr-2" size={16}/> Signing in…</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
